import React, { useState } from "react";
import MuiButton from "@mui/material/Button";

const ReadMore = ({
  expanded = false,
  comment,
  maxChar = 100,
  isArabic = false, // 👈 pass true when language is Arabic
}) => {
  const [isExpanded, setIsExpanded] = useState(expanded);

  const truncatedText =
    comment?.length > maxChar && !isExpanded
      ? `${comment.slice(0, maxChar)}.....`
      : comment;

  return (
    <span
      dir={isArabic ? "rtl" : "ltr"}
      style={{ unicodeBidi: "plaintext" }}
    >
      {truncatedText}

      {comment?.length > maxChar && (
        <MuiButton
          size="small"
          sx={{
            mx: "5px", // logical spacing works in RTL & LTR
            p: 0,
            color: "#1976d2",
            textTransform: "none",
            display: "inline",
          }}
          onClick={() => setIsExpanded(!isExpanded)}
        >
          {isExpanded ? "Read Less" : "Read More"}
        </MuiButton>
      )}
    </span>
  );
};

export default ReadMore;
